import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React from 'react';
import styled from 'styled-components';
import { pxToRem, getBackgroundShade } from 'utils/ui';
import { fillParent } from 'styles/mixins';
import UserGeneratedText from 'components/UserGeneratedText';
import Text from 'components/Text';
import ThemeSection from 'components/ThemeSection';
import { DescriptionIcon } from '../shared';
var hoverTriggerClass = 'card-hover-trigger';
var DescriptionOverlay = styled.div.withConfig({
  displayName: "HoverDescription__DescriptionOverlay",
  componentId: "sc-c9exno-0"
})(["", " color:", ";background:", ";border-radius:", ";border-bottom-left-radius:0;border-bottom-right-radius:0;opacity:0;transition:opacity 350ms ease-in;will-change:opacity,transform;.", ":hover &{opacity:1;transition-delay:100ms;}@media (max-width:", "){display:none;}"], fillParent, function (p) {
  return p.theme.text;
}, function (p) {
  return getBackgroundShade(p.theme);
}, function (p) {
  return pxToRem(p.theme.globals.borderRadius.large);
}, hoverTriggerClass, function (p) {
  return p.theme.globals.breakpoints.s;
});
var DescriptionContent = styled(Text).withConfig({
  displayName: "HoverDescription__DescriptionContent",
  componentId: "sc-c9exno-1"
})(["max-width:", ";opacity:0;transform:translateY(", ");transition:all 150ms ease-in;will-change:opacity,transform;.", ":hover &{opacity:1;transform:none;transition-delay:300ms;}"], pxToRem(520), pxToRem(-5), hoverTriggerClass);
var AnimatedDescriptionIcon = styled(DescriptionIcon).withConfig({
  displayName: "HoverDescription__AnimatedDescriptionIcon",
  componentId: "sc-c9exno-2"
})(["transition:all 300ms ease-in-out;will-change:transform;.", ":hover &{fill:white;transform:translateY(8px);transition-delay:200ms;}"], hoverTriggerClass);
function HoverDescription(_ref) {
  var description = _ref.description,
    id = _ref.id,
    icon = _ref.icon,
    _ref$maxLength = _ref.maxLength,
    maxLength = _ref$maxLength === void 0 ? 180 : _ref$maxLength;
  return /*#__PURE__*/React.createElement("div", {
    className: hoverTriggerClass
  }, /*#__PURE__*/React.createElement(ThemeSection, {
    withBackgroundImage: true,
    name: icon
  }, /*#__PURE__*/React.createElement(DescriptionOverlay, null, /*#__PURE__*/React.createElement(DescriptionContent, {
    id: id,
    p: "s",
    pl: "xl",
    size: "s",
    display: "block",
    as: "div"
  }, /*#__PURE__*/React.createElement(UserGeneratedText, {
    text: description,
    truncateLength: maxLength
  })))), /*#__PURE__*/React.createElement(AnimatedDescriptionIcon, null));
}
export default HoverDescription;